import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductShowcase.css';
import { API_BASE } from '../config/api';

const ClearanceSale = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [favorites, setFavorites] = useState(new Set());

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${API_BASE}/products?showcaseSection=clearance-sale&isFeaturedInShowcase=true&limit=4`);
      const data = await response.json();
      if (data.success && (Array.isArray(data.products) || Array.isArray(data.data))) {
        setProducts(data.products || data.data || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts([]);
    }
  };

  const toggleFavorite = (productId) => {
    setFavorites(prev => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(productId)) {
        newFavorites.delete(productId);
      } else {
        newFavorites.add(productId);
      }
      return newFavorites;
    });
  };

  const getImageUrl = (product) => {
    if (product.images && product.images.length > 0) {
      return product.images[0].startsWith('http') 
        ? product.images[0] 
        : `${API_BASE}${product.images[0]}`;
    }
    return null;
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product._id}`);
  };

  return (
    <section className="product-showcase-section">
      <div className="product-showcase-content">
        <h2 className="section-title">Clearance Sale</h2>
        
        <div className="products-grid">
          {products.map((product) => (
            <div 
              key={product._id} 
              className="product-card-arrival"
              onClick={() => handleProductClick(product)}
            >
              <div className="product-image-wrapper">
                <button 
                  className={`favorite-btn ${favorites.has(product._id) ? 'active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(product._id);
                  }}
                >
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill={favorites.has(product._id) ? "currentColor" : "none"}
                    stroke="currentColor" 
                    strokeWidth="1.5"
                  >
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </button>
                {getImageUrl(product) ? (
                  <img 
                    src={getImageUrl(product)} 
                    alt={product.name}
                    className="product-image"
                  />
                ) : (
                  <div className="product-placeholder"></div>
                )}
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">
                  ৳{typeof product.price === 'number' 
                    ? product.price.toFixed(2) 
                    : parseFloat(product.price).toFixed(2)}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <button className="shop-now-btn" onClick={() => navigate('/products?showcaseSection=clearance-sale')}>
          Shop More
        </button>
      </div>
    </section>
  );
};

export default ClearanceSale;
